import React from "react";
import { withTranslation } from "react-i18next";
import { debug } from "../../App";

class Pandadoc extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { id: null, loading: true, error: null };
  }

  render() {
    const { t } = this.props;

    if (this.state.error) return <div>{this.state.error}</div>;

    return !this.state.loading ? (
      <div className="placeholder" {...this.props}>
        <iframe src={`https://app.pandadoc.com/s/${this.state.id}`} width="100%" height="512" frameBorder={0} title="Athlete Agreement" />
      </div>
    ) : (
      <div>{t("loading")}...</div>
    );
  }

  componentDidMount() {
    debug("Pandadoc: componentDidMount");
  }
}

export default withTranslation()(Pandadoc);
